module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"video_upload_error":{"default":"동영상 업로드에 실패했습니다.","too_large":"동영상은 500MB까지 등록이 가능합니다.","invalid_type":"동영상 파일이 아닙니다."},"video_create_error":{"default":"동영상 등록 중 오류가 발생했습니다."}}}')
  delete Component.options._Ctor
}
